export default {
  header: 'Zmeniť jazyk'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/components/switchLang.js